module.exports = __webpack_public_path__ + "static/media/tree_silhouette.3e808b36.png";